import React, { useEffect, useReducer, useState } from 'react';
import tree from './../treeimg.gif';
import { initialstate, myreducer, fetchbygetmethod } from '../Commonfiles/Myreducer';
import Spinner from '../Commonfiles/spinner';
import Nodatafound from '../Commonfiles/nodatafound';
import { Gotohome } from '../Commonfiles/checkfortoken';

export default function Yourgroup(props) {
    const imagefromdb = "./uploads/";
    const imagedefault = "/assets/images/users/avatar-default.png";

    const [mydata, setmydata] = useReducer(myreducer, initialstate);
    const [previoustempID, setprevioustempID] = useState([]);

    useEffect(() => {
        getdata(props.dsname);
    }, [props.dsname]);

    useEffect(() => {
        setbackbutton();
    }, [previoustempID]);

    function getdata(tempid) {
        fetchbygetmethod(setmydata, 'yourgroup', { tempid });
    }

    function goBack(parentID, isDrill, newParentID) {
        if (!isDrill) {
            const last = previoustempID[previoustempID.length - 1];
            if (last) {
                getdata(last);
                setprevioustempID(previoustempID.slice(0, -1));
            }
        } else {
            setprevioustempID([...previoustempID, parentID]);
            getdata(newParentID);
        }
    }

    function setbackbutton() {
        const btn = document.getElementById('btngoback');
        if (btn) {
            btn.disabled = previoustempID.length <= 1;
        }
    }

    function findChildNodeIndex(childId) {
        return mydata.mypost.findIndex(row => row.ApplicantId === childId);
    }

    function findChildNodeByApplicantId(applicantId) {
        return mydata.mypost.find(row => row.ApplicantId === applicantId);
    }

    function Nodewithvalue({ index }) {
        const data = mydata.mypost[index];
        return (
            <div className='treelevel3child'>
                <div className='treenode' onClick={() => goBack(mydata.mypost[0].TempID, 1, data.TempID)}>
                    <div className='treenodeheader'>
                        <label>{data.ApplicantName}</label>
                        <label><span>{data.TempID}</span></label>
                    </div>
                    <div className='treenodebody'>
                        <div className='treephoto'>
                            <img src={data.ApplicantPhoto ? imagefromdb + data.ApplicantPhoto : process.env.PUBLIC_URL + imagedefault} alt="User" className="img-circle" />
                        </div>
                        <div className='treeinfo'>
                            <label>Sponsor ID: <span>{data.sponsorid}</span></label><br />
                            <label>Awareness ID:<span>{data.awarenessid}</span></label><br />
                            <label>Joining Date: <span>{data.date?.split('T')[0]}</span></label><br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function Nodewithoutvalue() {
        return (
            <div className='treelevel3child'>
                <div className='treenode'>
                    <div className='treenodebody'>
                        <div className='defaulttreephoto'>
                            <img src={process.env.PUBLIC_URL + imagedefault} alt="Default" className="img-circle" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function renderChildNode(childId) {
        const index = findChildNodeIndex(childId);
        return index !== -1 ? <Nodewithvalue key={index} index={index} /> : <Nodewithoutvalue />;
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="page-header-title">
                    <h4 className="page-title">My Group Tree</h4>
                </div>
                <div className="page-content-wrapper">
                    <div className="container">
                        <div className="panel panel-primary">
                            <div className="panel-body">
                                <div className='treeheader'>
                                    <div className='backButton'>
                                        <button id='btngoback' onClick={() => goBack(props.dsname, 0, props.dsname)}>Go Back</button>
                                    </div>
                                    <div className='resetButton'>
                                        <button onClick={() => getdata(props.dsname)}>Reset</button>
                                    </div>
                                </div>
                                <hr />
                                {mydata.initialstage ? null : mydata.myloading ? (
                                    <Spinner />
                                ) : (
                                    mydata.mypost && mydata.mypost.length > 0 ? (
                                        <div className="row">
                                            {/* Root Node */}
                                            <div className='treelevel1'>
                                                <div className='treenode'>
                                                    <div className='treenodeheader'>
                                                        <label>{mydata.mypost[0].ApplicantName}</label>
                                                        <label><span>{mydata.mypost[0].TempID}</span></label>
                                                    </div>
                                                    <div className='treenodebody'>
                                                        <div className='treephoto'>
                                                            <img src={mydata.mypost[0].ApplicantPhoto ? imagefromdb + mydata.mypost[0].ApplicantPhoto : process.env.PUBLIC_URL + imagedefault} alt="Root" className="img-circle" />
                                                        </div>
                                                        <div className='treeinfo'>
                                                            <label>Sponsor ID: <span>{mydata.mypost[0].sponsorid}</span></label><br />
                                                            <label>Awareness ID:<span>{mydata.mypost[0].awarenessid}</span></label><br />
                                                            <label>Joining Date: <span>{mydata.mypost[0].date?.split('T')[0]}</span></label><br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Level 2 */}
                                            <div className='treebranch'><img src={tree} alt="" /></div>
                                            <div className='treelevel2'>
                                                {renderChildNode(mydata.mypost[0].LeftChild)}
                                                {renderChildNode(mydata.mypost[0].RightChild)}
                                            </div>

                                            {/* Level 3 */}
                                            <div className='treebranch'>
                                                <img src={tree} alt="" /><img src={tree} alt="" />
                                            </div>
                                          <div className='treelevel3'>

                                            {/* Right subtree children */}

                                          {/* {mydata.mypost[2] && renderChildNode(mydata.mypost[2].LeftChild)}
                                          {mydata.mypost[1] && renderChildNode(mydata.mypost[1].RightChild)}
                                 */}

                                 
                                           {/* Left subtree children */}
                               
                                          {/* {mydata.mypost[1] && renderChildNode(mydata.mypost[1].LeftChild)}
                                          {mydata.mypost[2] && renderChildNode(mydata.mypost[2].RightChild)} */}

{renderChildNode(mydata.mypost[0].LeftChild && findChildNodeByApplicantId(mydata.mypost[0].LeftChild)?.LeftChild)}
{renderChildNode(mydata.mypost[0].LeftChild && findChildNodeByApplicantId(mydata.mypost[0].LeftChild)?.RightChild)}

    {/* Right subtree children */}
    {/* {mydata.mypost[2] && renderChildNode(mydata.mypost[2].LeftChild)}
    {mydata.mypost[1] && renderChildNode(mydata.mypost[1].RightChild)} */}

{renderChildNode(mydata.mypost[0].RightChild && findChildNodeByApplicantId(mydata.mypost[0].RightChild)?.LeftChild)}
{renderChildNode(mydata.mypost[0].RightChild && findChildNodeByApplicantId(mydata.mypost[0].RightChild)?.RightChild)}
</div>

                                        </div>
                                    ) : <Nodatafound />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Gotohome mydata={mydata} />
        </div>
    );
}
